import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../Components/Loading';
import SnackbarShow from '../../Components/SnackbarShow';
import { validateSession } from '../../API/APICalls';
import UserCreateImportForm from '../../Components/Mailbox/UserCreateImportForm';



const MailboxCreateImportPage = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [domainDetails, setDomainDetails] = useState(null);
    const [snackbarMessage, setSnackbarMessage] = useState({ open: false, message: '', severity: '' });


    const getSessionDetails = async (id) => {
        try {
            setLoading(true);
            const response = await validateSession(id);
            if (response.status === 200) {
                setDomainDetails(response.data);
                window.sessionStorage.setItem('domainDetails', JSON.stringify(response.data.domain_ids));
            } else {
                setSnackbarMessage({ open: true, message: response.data.message, severity: 'error' });
            }
        } catch (error) {
            setSnackbarMessage({ open: true, message: 'Something went wrong. Please try again later.', severity: 'error' });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { getSessionDetails(id) }, [id]);
    const snackbarMessageComp = (snackbarMessage.open) ? (<SnackbarShow data={snackbarMessage} setSnackbarMessage={setSnackbarMessage} />) : null;

    if (loading) return <Loading />

    let bulkCreateComp = (domainDetails === undefined || domainDetails === null) ? (
        <h1>Session is Invalid or domain details not present...!</h1>
    ) : (
        <UserCreateImportForm id={id} domainDetails={domainDetails} />
    );
    return (
        <>
            {snackbarMessageComp}
            {bulkCreateComp}
        </>
    );
};

export default MailboxCreateImportPage;